import { useContext, useEffect, useMemo } from 'react'

import { Box, Icon, Text, Timeline } from '@fairfashion/design-system'
import moment from 'moment'
import { useParams } from 'react-router-dom'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { StatusTag } from '../../components/StatusTag/status-tag.comp'

import { HeaderInfoItem } from './HeaderInfoItem/header-info-item.comp'
import {
  OrderProductionContext,
  OrderProductionProvider,
} from './order-production.context'
import * as Styles from './order-productions.styles'
import { OrderProductionStep } from './OrderProductionStep/order-production-step.comp'

const OrderProductionComp = () => {
  const { orderProduction, actions } = useContext(OrderProductionContext)

  const params = useParams()

  useEffect(() => {
    actions.getOrderProduction(params?.code ?? '')
  }, [])

  const getDate = (date?: Date) => {
    if (!date) return ''

    return moment(date).format('DD/MM/YYYY')
  }

  const timelineItems = useMemo(() => {
    if (!orderProduction?.orderProductionSteps) return [] as any

    const steps = []

    steps.push({
      color: 'success',
      marker: <Icon name="circle_fill" size={36} color="secondary" />,
      content: (
        <Box direction="column" paddingBottom={3}>
          <Box height="36px" alignItems="center">
            <Text fontWeight={500} color="success" size="small">
              INÍCIO
            </Text>
          </Box>
        </Box>
      ),
    })

    orderProduction?.orderProductionSteps?.forEach(
      (orderProductionStep, index) => {
        steps.push({
          color: 'success',
          marker: (
            <Box
              alignItems="center"
              justifyContent="center"
              gap={1}
              width="36px"
              height="36px"
              borderRadius="100%"
              border={{ color: 'secondary', width: 2 }}
            >
              <Icon name="circle_fill" size={16} color="secondary" />
            </Box>
          ),
          content: (
            <OrderProductionStep
              orderProductionStep={orderProductionStep}
              key={`order-production-step-${index}`}
            />
          ),
        })
      },
    )

    steps.push({
      color: 'success',
      marker: <Icon name="circle_fill" size={36} color="secondary" />,
      content: (
        <Box height="36px" alignItems="center">
          <Text fontWeight={500} color="success" size="small">
            FIM
          </Text>
        </Box>
      ),
    })

    return steps
  }, [orderProduction?.orderProductionSteps])

  return (
    <Box direction="column" gap={2} width="100%" padding={3}>
      <BackButton url="/order-productions" />

      <Styles.Header>
        <Box flex={1} direction="column" gap={2}>
          <Box gap={1}>
            <Text size="small" color="grey_3">
              Fábrica:
            </Text>
            <Text size="small">{orderProduction?.clientCompany?.name}</Text>
          </Box>
          <Box width="100%" gap={2} flexWrap="wrap">
            <Box flex={1} direction="column" gap={2}>
              <HeaderInfoItem
                icon="clipboard"
                color="primary"
                label="Ordem de Produção"
                value={orderProduction?.code}
              />
              <HeaderInfoItem
                icon="product_hunt"
                color="light_purple"
                label="Produto"
                value={orderProduction?.itemOrderProductions?.[0]?.description}
              />
              <HeaderInfoItem
                icon="calendar_schedule"
                color="lilac"
                label="Início da produção"
                value={getDate(
                  orderProduction?.orderProductionSteps?.[0]?.startDate,
                )}
              />
            </Box>

            <Box flex={1} direction="column" gap={2}>
              <HeaderInfoItem
                icon="checkbox_circle"
                color="success"
                label="Status"
                value={<StatusTag status={orderProduction?.status} />}
              />
              <HeaderInfoItem
                icon="barcode_box"
                color="purple"
                label="SKU"
                value={orderProduction?.itemOrderProductions?.[0]?.code}
              />
              <HeaderInfoItem
                icon="calendar_check"
                color="light_blue"
                label="Fim da produção"
                value={getDate(
                  orderProduction?.orderProductionSteps?.at(-1)?.endDate,
                )}
              />
            </Box>
          </Box>
        </Box>
      </Styles.Header>

      <Box width="100%" direction="column" marginTop={3}>
        <Text size="medium">Etapas do processo produtivo</Text>
      </Box>
      {orderProduction?.orderProductionSteps && (
        <Timeline items={timelineItems} />
      )}
    </Box>
  )
}

export const OrderProduction = () => {
  return (
    <OrderProductionProvider>
      <OrderProductionComp />
    </OrderProductionProvider>
  )
}
